<template>
  <div class="dropdown_container">
    <div class="dropdown_input">
      <input type="text" readonly class="form-control form-control-sm" :value="selected" placeholder="" />
    </div>
    <div class="dropdown_content"></div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  data() {
    return {
      selected: ""
    };
  }
};
</script>

<style>
</style>